import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View, useColorScheme } from 'react-native';

export default function App() {
  const colorScheme = useColorScheme(); // Detects the system color scheme

  // Define styles for light and dark modes
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colorScheme === 'dark' ? '#121212' : '#fff',
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      fontSize: 100,
      color: colorScheme === 'dark' ? '#fff' : '#333',
    },
    subtext: {
      fontSize: 50,
      color: colorScheme === 'dark' ? '#fff' : '#333',
    },
  });

  return (
    <View style={styles.container}>
      <Text style={styles.text}>Al Dente</Text>
      <Text style={styles.subtext}>Recipe app</Text>
      <StatusBar style={colorScheme === 'dark' ? 'light' : 'dark'} />
    </View>
  );
}